import { get } from '@/admin/services/api/http-utils';

export default {
  state: {
    partnerGroups: [],
  },
  mutations: {
    setPartnerGroups(state, data) {
      state.partnerGroups = data;
    },
  },
  actions: {
    async fetchPartnerGroups({ commit }) {
      const { data } = await get('/admin/customer-group');
      commit('setPartnerGroups', data.data);
    },
  },
  getters: {},
};
